import { make } from 'vuex-pathify'
import currentPost from './blog/CurrentPost'
import { WordpressService } from '@/resources/axios'

WordpressService.setBaseUrl(process.env.VUE_APP_WP_API_URL)

const state = {
  categories: null,
  posts: null,
  currentPost
}

const stripLearnMore = function (str) {
  return str.replace(/<p class="link-more">.*<\/p>/g, '')
}

const getters = make.getters(state)
const mutations = make.mutations(state)
const actions = {
  ...make.actions(state),
  async fetchCategories ({ commit, state }, d = {}) {
    try {
      let response = await WordpressService.fetchCategories(d)
      const categs = response.data
      let categories = []
      let i = categs.length

      while (i--) {
        let cat = {}
        cat.image = {}
        cat.image.sizes = {}
        cat.image.sizes.original = {}
        cat.image.sizes.large = {}
        cat.image.sizes.medium = {}
        cat.image.sizes.thumbnail = {}

        cat.id = categs[i].id
        cat.title = categs[i].name
        cat.description = categs[i].description
        cat.slug = categs[i].slug
        cat.articles = categs[i]['_links']['wp:post_type']

        if (typeof categs[i].acf.image !== 'undefined') {
          cat.image.alt = categs[i].acf.image.alt
          cat.image.caption = categs[i].acf.image.caption

          // ACF IMAGE: Original Size
          cat.image.sizes.original.url = categs[i].acf.image.url
          cat.image.sizes.original.width = categs[i].acf.image.width
          cat.image.sizes.original.height = categs[i].acf.image.height

          // ACF IMAGE: Large Size
          cat.image.sizes.large.url = categs[i].acf.image.sizes.large
          cat.image.sizes.large.width = categs[i].acf.image.sizes['large-width']
          cat.image.sizes.large.height = categs[i].acf.image.sizes['large-height']

          // ACF IMAGE: Medium Size
          cat.image.sizes.medium.url = categs[i].acf.image.sizes.medium
          cat.image.sizes.medium.width = categs[i].acf.image.sizes['medium-width']
          cat.image.sizes.medium.height = categs[i].acf.image.sizes['medium-height']

          // ACF IMAGE: Medium Size
          cat.image.sizes.thumbnail.url = categs[i].acf.image.sizes.thumbnail
          cat.image.sizes.thumbnail.width = categs[i].acf.image.sizes['thumbnail-width']
          cat.image.sizes.thumbnail.height = categs[i].acf.image.sizes['thumbnail-height']
        } else {
          cat.image.alt = null
          cat.image.caption = null

          // ACF IMAGE: Original Size
          cat.image.sizes.original.url = null
          cat.image.sizes.original.width = null
          cat.image.sizes.original.height = null

          // ACF IMAGE: Large Size
          cat.image.sizes.large.url = null
          cat.image.sizes.large.width = null
          cat.image.sizes.large.height = null

          // ACF IMAGE: Medium Size
          cat.image.sizes.medium.url = null
          cat.image.sizes.medium.width = null
          cat.image.sizes.medium.height = null

          // ACF IMAGE: Medium Size
          cat.image.sizes.thumbnail.url = null
          cat.image.sizes.thumbnail.width = null
          cat.image.sizes.thumbnail.height = null
        }

        categories.push(cat)
      }

      commit('SET_CATEGORIES', categories)
    } catch (err) {
      throw err
    }
  },
  async fetchPosts ({ commit, state }, d = {}) {
    try {
      let response = await WordpressService.fetchPosts(d)
      let posts = []
      response.data.forEach((data) => {
        let post = {}
        let postImages = data['_embedded']['wp:featuredmedia']
        let postTerm = data['_embedded']['wp:term'][0][0]

        post.id = data.id
        post.slug = data.slug
        post.title = data.title.rendered
        post.datePublished = data.date
        post.dateModified = data.modified
        post.excerpt = stripLearnMore(data.excerpt.rendered)
        post.image = {}
        post.category = {}

        if (typeof postTerm !== 'undefined') {
          post.category.title = postTerm.name
          post.category.slug = postTerm.slug
          post.category.id = postTerm.id

          if (postTerm.acf !== 'undefined') {
            post.category.image = {}
            post.category.image.url = postTerm.acf.image.url
            post.category.image.alt = postTerm.acf.image.alt
            post.category.image.width = postTerm.acf.image.width
            post.category.image.height = postTerm.acf.image.height
          }
        }

        if (typeof postImages !== 'undefined') {
          postImages.forEach((image) => {
            post.image.url = image.media_details.sizes.thumbnail.source_url
            post.image.alt = image.alt_text
            post.image.caption = image.caption.rendered
            post.image.width = image.media_details.sizes.thumbnail.width
            post.image.height = image.media_details.sizes.thumbnail.height
          })
        } else {
          post.image.altText = 'No Article Image'
          post.image.caption = 'No Article Image'
          post.image.width = 150
          post.image.height = 150
          post.image.url = 'https://via.placeholder.com/150x150.png?text=No+Preview+Image'
        }

        posts.push(post)
      })

      commit('SET_POSTS', posts)
    } catch (err) {
      throw err
    }
  },
  async fetchPost ({ commit, state }, d = {}) {
    try {
      let response = await WordpressService.fetchPost(d.id, d.params)
      let post = {}
      let postImages = response.data['_embedded']['wp:featuredmedia']

      post.id = response.data.id
      post.slug = response.data.slug
      post.title = response.data.title.rendered
      post.datePublished = response.data.date
      post.dateModified = response.data.modified
      post.content = response.data.content.rendered
      post.image = {}

      if (typeof postImages !== 'undefined') {
        postImages.forEach((image) => {
          post.image.altText = image.alt_text
          post.image.width = image.media_details.sizes.full.width
          post.image.height = image.media_details.sizes.full.height
          post.image.url = image.media_details.sizes.full.source_url
          post.image.useFilter = image.acf.use_filter
        })
      } else {
        post.image.altText = null
        post.image.caption = null
        post.image.width = null
        post.image.height = null
        post.image.url = null
        post.image.useFilter = null
      }
      commit('SET_CURRENT_POST', post)
    } catch (err) {
      throw err
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
